var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], { autoescape: true });
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/codebuild/output/src2118274201/src/tv-monitor-ui/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["src/js/view/Config.njk"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<style>\n    @keyframes blinker {\n        50% {\n            opacity: 0;\n        }\n    }\n\n    .Dashboard .main .region-header {\n        ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "settings")),"header")),"height")) {
output += " height: ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "settings")),"header")),"height"), env.opts.autoescape);
output += ";";
;
}
output += "\n    }\n\n    .DashboardHeader {\n        color: ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "settings")),"header")),"textColor"), env.opts.autoescape);
output += ";\n    }\n\n    .DashboardHeader .background {\n        background-color: ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "settings")),"header")),"backgroundColor"), env.opts.autoescape);
output += ";\n        ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "settings")),"header")),"backgroundType") == "image") {
output += "\n            background-image: url(";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "headerBackgroundUrl"), env.opts.autoescape);
output += ");\n            background-position: ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "settings")),"header")),"backgroundPosition"), env.opts.autoescape);
output += ";\n            background-size: ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "settings")),"header")),"backgroundSize"), env.opts.autoescape);
output += ";\n        ";
;
}
output += "\n    }\n\n    .DashboardHeader .details .logo img {\n        height: ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "settings")),"header")),"logoSize"), env.opts.autoescape);
output += ";\n    }\n\n    .EventSummary {\n        background-color: ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "settings")),"events")),"rowBackgroundColorOdd"), env.opts.autoescape);
output += ";\n        color: ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "settings")),"events")),"rowTextColor"), env.opts.autoescape);
output += ";\n    }\n    .EventSummary:nth-child(even) {\n        background-color: ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "settings")),"events")),"rowBackgroundColorEven"), env.opts.autoescape);
output += ";\n    }\n\n    .EventSummary .availability.available {\n        color: ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "settings")),"events")),"availabilityColorAvailable"), env.opts.autoescape);
output += ";\n    }\n    .EventSummary .availability.half-full {\n        color: ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "settings")),"events")),"availabilityColorHalfFull"), env.opts.autoescape);
output += ";\n    }\n    .EventSummary .availability.almost-full {\n        color: ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "settings")),"events")),"availabilityColorAlmostFull"), env.opts.autoescape);
output += ";\n        ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "settings")),"events")),"availabilityBlink")) {
output += "\n            animation: blinker 1s linear infinite;\n        ";
;
}
output += "\n    }\n    .EventSummary .availability .full {\n        color: ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "settings")),"events")),"availabilityColorFull"), env.opts.autoescape);
output += ";\n    }\n</style>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["src/js/view/Config.njk"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./src/js/view/Config.njk
// module id = 191
// module chunks = 0